import { inject } from "mobx-react";
import { Fragment, useMemo } from "react";

import type { BlockInterface } from "@ihr-radioedit/inferno-core";
import type { FeedResultFragment } from "@ihr-radioedit/inferno-webapi";
import { Heading } from "../../../../core/ui";
import { getFeedSubtitle } from "../../lib/coastFeed";
import { CoastFeedNavigation } from "./coast-feed-navigation/CoastFeedNavigation.component";
import { CoastFeedAds } from "./CoastFeedAds.component";
import { CoastFeedArticleItem } from "./CoastFeedArticleItem.component";
import { CoastFeedNoResults } from "./CoastFeedNoResults.component";
import type { Store } from "@inferno/renderer-shared-core";

export interface CoastFeedArticlesProps {
  content: FeedResultFragment[] | null;
  block: BlockInterface;
  store?: Store;
  title: string;
}

export const CoastFeedArticles = inject("store")(({ store, content, block, title }: CoastFeedArticlesProps) => {
  if (!store) {
    return null;
  }

  const subtitle = useMemo(() => getFeedSubtitle(store.routeParams), [store.routeParams]);

  // only display the header block if there are no feed filters selected
  const displayFirstItemBlock = !Object.keys(store.routeParams).length;

  const feedCardsContent = displayFirstItemBlock ? content?.slice(1) : content;

  return (
    <Fragment>
      <Heading level={2}>{title}</Heading>
      <Heading level={3}>{subtitle}</Heading>

      {content?.length && displayFirstItemBlock ? (
        <section className="coast-feed-header">
          <CoastFeedArticleItem item={content[0]} />
        </section>
      ) : null}

      <CoastFeedNavigation />

      {feedCardsContent?.length ? (
        <div className="feed-cards">
          {feedCardsContent.map((item, itemIdx) => (
            <Fragment key={item.id}>
              <CoastFeedArticleItem item={item} />
              <CoastFeedAds
                blockSize={block.value.size}
                itemCount={content?.length || 0}
                includeItemAd={false}
                blockId={block.id}
                itemIdx={itemIdx}
              />
            </Fragment>
          ))}
        </div>
      ) : (
        <CoastFeedNoResults />
      )}
    </Fragment>
  );
});

export default CoastFeedArticles;
